"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompanyInformationSearchModel = instanceOfCompanyInformationSearchModel;
exports.CompanyInformationSearchModelFromJSON = CompanyInformationSearchModelFromJSON;
exports.CompanyInformationSearchModelFromJSONTyped = CompanyInformationSearchModelFromJSONTyped;
exports.CompanyInformationSearchModelToJSON = CompanyInformationSearchModelToJSON;
exports.CompanyInformationSearchModelToJSONTyped = CompanyInformationSearchModelToJSONTyped;
/**
 * Check if a given object implements the CompanyInformationSearchModel interface.
 */
function instanceOfCompanyInformationSearchModel(value) {
    return true;
}
function CompanyInformationSearchModelFromJSON(json) {
    return CompanyInformationSearchModelFromJSONTyped(json, false);
}
function CompanyInformationSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'websiteRenderingName': json['websiteRenderingName'] == null ? undefined : json['websiteRenderingName'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
    };
}
function CompanyInformationSearchModelToJSON(json) {
    return CompanyInformationSearchModelToJSONTyped(json, false);
}
function CompanyInformationSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'companyName': value['companyName'],
        'websiteRenderingName': value['websiteRenderingName'],
        'useStatus': value['useStatus'],
    };
}
